import React, { useEffect, useRef, useState } from "react";
import { Tooltip, Popover } from "@mui/material";
import { IconButton } from "@mui/material";

const MessageA81 = (props) => {
    const [clicked, setClicked] = useState(false);

    // const checkButton = () => {
    //   let userText = props?.item?.text;
    //   const buttonTextOptions = ["Yes", "No", "Submit", "Confirm" ,"Send OTP"];

    //   // Check if any of the options are included in userText
    //   if (buttonTextOptions.some(option => userText.includes(option))) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
    useEffect(() => {
        props.setShowFeedbackPopUP(props?.item?.data)
    }, [])

    return (
        <>

        </>
    );
};

export default MessageA81;
